import { render } from "./feedback.vue?vue&type=template&id=55c24bf9&scoped=true&ts=true"
import script from "./feedback.vue?vue&type=script&lang=ts"
export * from "./feedback.vue?vue&type=script&lang=ts"

import "./feedback.vue?vue&type=style&index=0&id=55c24bf9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c24bf9"]])

export default __exports__